import { useTranslation } from "react-i18next";

import { ROUTES } from "@/shared";

import FilterDropdown from "../../FilterDropdown/FilterDropdown";
import { FILTER_NAMES, TRANSLATE_STRINGS } from "../../types";

const DriverFilesFilters = () => {
  const { t } = useTranslation();

  return (
    <>
      <FilterDropdown
        route={ROUTES.DriverFiles}
        filterName={FILTER_NAMES.Schedule}
        placeholder={t("Filter##schedule")}
        translateString={TRANSLATE_STRINGS.Table}
      />
      <FilterDropdown
        route={ROUTES.DriverFiles}
        filterName={FILTER_NAMES.Imei}
        placeholder={t("Filter##device imei")}
      />
    </>
  );
};

export default DriverFilesFilters;
